import Question from 'models/task/question/Question';

/**
 * Class representing a guess question.
 */
export default class GuessQuestion extends Question {}
